<template>
  <div class="orders">
    <modal name="confirmOrderModal" :adaptive="true" :width="300" :height="250">
      <h3 class="my-6 text-center">{{ $t('Estimated Time for Order') }}</h3>
      <form class="px-8" autocomplete="off">
        <div class="mb-4">
          <label class="block mb-2 text-sm font-bold text-gray-700" for="time"> {{ $t('Estimated Time') }}: </label>
          <input
            class="w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
            id="time"
            type="text"
            v-model="order.time"
          />
        </div>
        <div class="flex justify-center">
          <button
            class="flex items-center px-6 py-2 font-light text-center text-white bg-green-400 rounded-full"
            @click="handleConfirmTime"
            type="button"
          >
            {{ $t('Approve') }}
          </button>
        </div>
      </form>
    </modal>

    <modal name="changeDeliveryTimeModal" :adaptive="true" :width="300" :height="250">
      <h3 class="my-6 text-center">{{ $t('Estimated Time') }}:</h3>
      <form class="px-8" autocomplete="off">
        <div class="mb-4">
          <label class="block mb-2 text-sm font-bold text-gray-700" for="time"> {{ $t('Estimated Time') }}: </label>
          <input
            class="w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
            id="time"
            type="text"
            v-model="activeOrderTime"
          />
        </div>
        <div class="flex justify-center">
          <button
            class="flex items-center px-6 py-2 font-light text-center text-white bg-green-400 rounded-full"
            @click="handleConfirmTimeChange"
            type="button"
          >
            {{ $t('Change') }}
          </button>
        </div>
      </form>
    </modal>

    <modal name="replacementModal" :adaptive="true" :width="750" :height="'auto'" scrollable>
      <h3 class="my-6 text-center">{{ $t('Recommended Replacements') }}</h3>

      <div
        class="flex items-center justify-between px-2 py-2 mx-6 mb-4 border border-gray-200 rounded-lg shadow-lg"
        v-for="(item, index) in replacementOrderItems"
        :key="index"
      >
        <div>
          {{ item.name }}
        </div>
        <div>{{ $t('Replace with') }}</div>
        <div>
          <select class="block w-full mt-1 form-select" @change="handleReplaceItem({ index, event: $event })">
            <option value="no">{{ $t("Don't replace") }}</option>
            <option v-for="(menuOption, index) in menu" :value="index" :key="index">{{ menuOption.name }}</option>
          </select>
        </div>
      </div>
      <div class="px-2 mx-6 mb-4">
        <label class="block mb-2 text-sm font-bold text-gray-700" for="replacementReason"> {{ $t('Reason') }}: </label>
        <input
          class="w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
          id="replacementReason"
          type="text"
          v-model="replacementReason"
        />
      </div>

      <div class="flex justify-center mb-4">
        <button
          class="flex items-center px-6 py-2 mt-6 font-light text-center text-white bg-green-400 rounded-full"
          @click="handleConfirmReplacement"
          type="button"
        >
          {{ $t('Offer Replacements') }}
        </button>
      </div>
    </modal>

    <modal name="rejectOrderModal" :adaptive="true" :width="300" :height="250">
      <h3 class="my-6 text-center">{{ $t('Reject Order') }}</h3>

      <form class="px-8" autocomplete="off">
        <div class="mb-4">
          <label class="block mb-2 text-sm font-bold text-gray-700" for="reason">
            {{ $t('Reason') }}
          </label>
          <input
            class="w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
            id="reason"
            type="text"
            v-model="order.rejectReason"
          />
        </div>
        <div class="flex justify-center">
          <button
            class="flex items-center px-6 py-2 font-light text-center text-white bg-red-700 rounded-full"
            @click="handleConfirmReject"
            type="button"
          >
            {{ $t('Reject') }}
          </button>
        </div>
      </form>
    </modal>

    <section class="px-4 py-8 mx-10 mt-10 mb-4 bg-white rounded-lg shadow-xl">
      <div v-if="customerRejectedOrders.length > 0" class="mb-4">
        <div class="flex">
          <h2 class="text-xl">{{ $t('Rejected Replacements') }}</h2>
        </div>
        <div class="w-full mt-6">
          <table class="w-full table-fixed">
            <thead class="text-left">
              <tr>
                <th class="w-1/12 px-4 py-2">#</th>
                <th class="w-7/12 px-4 py-2">{{ $t('Name') }}</th>
                <th class="w-7/12 px-4 py-2">{{ $t('Reason') }}</th>
                <th class="w-4/12 px-4 py-2 text-right">{{ $t('Actions') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr class="border-t border-b" v-for="(item, index) in customerRejectedOrders" :key="index">
                <td class="px-4 py-2">{{ item.index + 1 }}</td>
                <td class="px-4 py-2">
                  <span
                    v-for="(i, insideIndex) in parseItemsToRow(item.items)"
                    :key="insideIndex"
                    class="flex items-center mb-1"
                  >
                    <p class="w-56 mx-1 font-bold">{{ i[0] }}</p>
                    <p class="mx-1 font-bold">x</p>
                    <p class="w-10 px-3 py-1 text-white rounded-lg bg-app-orange">{{ i[1] }}</p>
                  </span>
                </td>
                <td class="px-4 py-2">{{ item.customerRejectReason }}</td>
                <td class="flex justify-end py-2">
                  <button
                    type="button"
                    class="flex items-center px-6 py-2 font-light text-center text-white bg-blue-500 rounded-full"
                    @click="handleReplace(index, 'rejected')"
                  >
                    {{ $t('Offer Replacements') }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div>
        <div class="flex">
          <h2 class="text-xl">{{ $t('Pending Orders') }}</h2>
        </div>
        <div class="w-full mt-6">
          <table class="w-full table-fixed">
            <thead class="text-left">
              <tr>
                <th class="w-1/12 px-4 py-2">#</th>
                <th class="w-2/12 px-4 py-2">{{ $t('Name') }}</th>
                <th class="w-2/12 px-4 py-2">{{ $t('Description') }}</th>
                <th class="w-2/12 px-4 py-2">{{ $t('Table Number') }}</th>
                <th class="w-2/12 px-4 py-2">{{ $t('Note') }}</th>
                <th class="w-3/12 px-4 py-2 text-right">{{ $t('Actions') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr class="border-t border-b" v-for="(item, index) in pendingOrders" :key="index">
                <td class="px-4 py-2">{{ item.index + 1 }}</td>
                <td class="px-4 py-2">
                  <span
                    v-for="(i, insideIndex) in parseItemsToRow(item.items)"
                    :key="insideIndex"
                    class="flex items-center mb-1"
                  >
                    <p class="w-56 mx-1 font-bold">{{ i[0] }}</p>
                    <p class="mx-1 font-bold">x</p>
                    <p class="w-10 px-3 py-1 text-white rounded-lg bg-app-orange">{{ i[1] }}</p>
                  </span>
                </td>
                <td class="px-4 py-2 font-bold">
                  <span
                    v-for="(i, insideIndex) in parseItemDescriptionToRow(item.items)"
                    :key="insideIndex"
                    class="flex items-center mb-1"
                  >
                    <p class="mx-1 font-bold">{{ i[1] }}</p>
                  </span>
                </td>
                <td class="px-4 py-2 font-bold">
                  <span>{{ item.table || '' }}</span>
                </td>
                <td class="px-4 py-2 font-bold">
                  <span class="text-white rounded-lg bg-app-green" :class="{ 'px-2 py-2': item.note.length > 0 }">{{
                    item.note || ''
                  }}</span>
                </td>
                <td class="py-2 text-right">
                  <eva-icon
                    class="mr-2"
                    name="checkmark-circle-2-outline"
                    animation="pulse"
                    :width="tableIconSize"
                    :height="tableIconSize"
                    fill="#4A5568"
                    @click="handleConfirm(item.index)"
                  />
                  <eva-icon
                    class="ml-2 mr-2"
                    name="edit-2-outline"
                    animation="pulse"
                    :width="tableIconSize"
                    :height="tableIconSize"
                    fill="#4A5568"
                    @click="handleReplace(item.index, 'pending')"
                  />
                  <eva-icon
                    class="ml-2"
                    name="trash-outline"
                    animation="pulse"
                    :width="tableIconSize"
                    :height="tableIconSize"
                    fill="#c53030"
                    @click="handleReject(item.index, 'pending')"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="mt-8 border-t">
        <div class="flex">
          <h2 class="text-xl">{{ $t('In Progress') }}</h2>
        </div>
        <div class="w-full mt-6">
          <table class="w-full table-fixed">
            <thead class="text-left">
              <tr>
                <th class="w-1/12 px-4 py-2">#</th>
                <th class="w-2/12 px-4 py-2">{{ $t('Name') }}</th>
                <th class="w-2/12 px-4 py-2">{{ $t('Description') }}</th>
                <th class="w-2/12 px-4 py-2">{{ $t('Table Number') }}</th>
                <th class="w-2/12 px-4 py-2">{{ $t('Note') }}</th>
                <th class="w-1/12 px-4 py-2 text-right">{{ $t('Time Left') }}</th>
                <th class="w-2/12 px-4 py-2 text-right">{{ $t('Actions') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr class="border-t border-b" v-for="(item, index) in inProgressOrders" :key="index">
                <td class="px-4 py-2">{{ item.index + 1 }}</td>
                <td class="px-4 py-2">
                  <span
                    v-for="(i, insideIndex) in parseItemsToRow(item.items)"
                    :key="insideIndex"
                    class="flex items-center mb-1"
                  >
                    <p class="w-56 mx-1 font-bold">{{ i[0] }}</p>
                    <p class="mx-1 font-bold">x</p>
                    <p class="w-10 px-3 py-1 text-white rounded-lg bg-app-orange">{{ i[1] }}</p>
                  </span>
                </td>
                <td class="px-4 py-2 font-bold">
                  <span
                    v-for="(i, insideIndex) in parseItemDescriptionToRow(item.items)"
                    :key="insideIndex"
                    class="flex items-center mb-1"
                  >
                    <p class="mx-1 font-bold">{{ i[1] }}</p>
                  </span>
                </td>
                <td class="px-4 py-2 font-bold">
                  <span>{{ item.table || '' }}</span>
                </td>
                <td class="px-4 py-2 font-bold">
                  <span class="text-white rounded-lg bg-app-green" :class="{ 'px-2 py-2': item.note.length > 0 }">{{
                    item.note || ''
                  }}</span>
                </td>
                <td class="px-4 py-2 text-right">{{ item.timeLeft.min }}:{{ item.timeLeft.sec }}</td>
                <td class="py-2 text-right">
                  <eva-icon
                    class="mr-2"
                    name="checkmark-circle-2-outline"
                    animation="pulse"
                    :width="tableIconSize"
                    :height="tableIconSize"
                    fill="#4A5568"
                    @click="handleOrderReady(item.index)"
                  />
                  <eva-icon
                    class="ml-2 mr-2"
                    name="clock-outline"
                    animation="pulse"
                    :width="tableIconSize"
                    :height="tableIconSize"
                    fill="#ecc94b"
                    @click="handleChangeDeliveryTime(item.index)"
                  />
                  <eva-icon
                    class="ml-2 mr-2"
                    name="printer-outline"
                    animation="pulse"
                    :width="tableIconSize"
                    :height="tableIconSize"
                    fill="#69D391"
                    @click="handlePrint(item.index)"
                  />
                  <eva-icon
                    class="ml-2"
                    name="trash-outline"
                    animation="pulse"
                    :width="tableIconSize"
                    :height="tableIconSize"
                    fill="#c53030"
                    @click="handleReject(item.index, 'inprogress')"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="mt-8 border-t">
        <div class="flex">
          <h2 class="text-xl">{{ $t('Waiting Bill') }}</h2>
        </div>
        <div class="w-full mt-6">
          <table class="w-full table-fixed">
            <thead class="text-left">
              <tr>
                <th class="w-1/12 px-4 py-2">#</th>
                <th class="w-4/12 px-4 py-2">{{ $t('Name') }}</th>
                <th class="w-3/12 px-4 py-2">{{ $t('Table Number') }}</th>
                <th class="w-2/12 px-4 py-2 text-right">{{ $t('Amount') }}</th>
                <th class="w-2/12 px-4 py-2 text-right">{{ $t('Send Bill') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr class="border-t border-b" v-for="(item, index) in waitingBillOrders" :key="index">
                <td class="px-4 py-2">{{ item.index + 1 }}</td>
                <td class="px-4 py-2">
                  <span
                    v-for="(i, insideIndex) in parseItemsToRow(item.items)"
                    :key="insideIndex"
                    class="flex items-center mb-1"
                  >
                    <p class="w-56 mx-1 font-bold">{{ i[0] }}</p>
                    <p class="mx-1 font-bold">x</p>
                    <p class="w-10 px-3 py-1 text-white rounded-lg bg-app-orange">{{ i[1] }}</p>
                  </span>
                </td>
                <td class="px-4 py-2">
                  <span>{{ item.table || '' }}</span>
                </td>
                <td class="px-4 py-2 text-right">${{ item.total.toFixed(2) }}</td>
                <td class="py-2 text-right">
                  <eva-icon
                    class="mr-2"
                    name="checkmark-circle-2-outline"
                    animation="pulse"
                    :width="tableIconSize"
                    :height="tableIconSize"
                    fill="#69D391"
                    @click="handleSendBill(item.index)"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import moment from 'moment';
import { db, auth } from '@/firebase';

const ding = require('../../assets/ding.mp3');
const billSound = require('../../assets/bill.mp3');

export default {
  name: 'Orders',
  watch: {
    pendingOrders: function po(newPO) {
      if (newPO.length > 0 && !this.firstInit) {
        const audio = new Audio(ding);
        audio.play();
      }
    },
    customerRejectedOrders: function cro(newCR, oldCR) {
      if (newCR > oldCR && !this.firstInit) {
        const audio = new Audio(ding);
        audio.play();
      }
    },
    waitingBillOrders: function cro(newCR) {
      if (newCR.length > 0 && !this.firstInit) {
        const audio = new Audio(billSound);
        audio.play();
      }
    },
  },
  async created() {
    const { uid } = auth.currentUser;
    await db
      .collection(`/restaurants/${uid}/orders`)
      .where('status', '==', 'pending')
      .onSnapshot(querySnapshot => {
        const pendingOrders = [];
        let index = 0;
        querySnapshot.forEach(doc => {
          pendingOrders.push({ ...doc.data(), id: doc.id, index });
          index += 1;
        });
        this.pendingOrders = pendingOrders;
      });

    await db
      .collection(`/restaurants/${uid}/orders`)
      .where('status', '==', 'customerRejected')
      .onSnapshot(querySnapshot => {
        const customerRejectedOrders = [];
        let index = 0;
        querySnapshot.forEach(doc => {
          customerRejectedOrders.push({ ...doc.data(), id: doc.id, index });
          index += 1;
        });
        this.customerRejectedOrders = customerRejectedOrders;
      });

    await db
      .collection(`/restaurants/${uid}/orders`)
      .where('status', '==', 'approved')
      .onSnapshot(querySnapshot => {
        const inProgressOrders = [];
        let index = 0;
        querySnapshot.forEach(doc => {
          const d = doc.data();
          const { min, sec } = this.timeLeft(d);
          inProgressOrders.push({ ...d, id: doc.id, index, timeLeft: { min, sec } });
          index += 1;
        });
        this.inProgressOrders = inProgressOrders;
      });

    await db
      .collection(`/restaurants/${uid}/orders`)
      .where('status', '==', 'closed')
      .onSnapshot(querySnapshot => {
        const waitingBillOrders = [];
        let index = 0;
        querySnapshot.forEach(doc => {
          const d = doc.data();
          const total = this.itemsTotal(d.items);
          waitingBillOrders.push({ ...d, id: doc.id, index, total });
          index += 1;
        });
        this.waitingBillOrders = waitingBillOrders;
      });

    const restaurant = await db
      .collection('restaurants')
      .doc(uid)
      .get();

    if (restaurant.exists) {
      const { menu } = restaurant.data();
      if (menu) {
        this.menu = menu;
      }
    }
    this.firstInit = false;
    this.countDownTimer();
    this.orderSound();
  },
  data() {
    return {
      tableIconSize: 30,
      order: {
        time: '',
        orderIndex: '',
        rejectReason: '',
        replacement: {
          name: '',
          reason: '',
        },
      },
      pendingOrders: [],
      inProgressOrders: [],
      waitingBillOrders: [],
      customerRejectedOrders: [],
      menu: [],
      replacements: {},
      rejectMode: 'pending',
      activeOrderIndex: 0,
      activeOrderTime: 0,
      replacementReason: '',
      replaceMode: '',
      firstInit: true,
    };
  },
  computed: {
    replacementOrderItems() {
      const { orderIndex } = this.order;

      if (orderIndex !== '' && this.replaceMode === 'pending' && this.pendingOrders.length > 0) {
        return this.pendingOrders[+orderIndex].items;
      }
      if (orderIndex !== '' && this.replaceMode === 'rejected' && this.customerRejectedOrders.length > 0) {
        return this.customerRejectedOrders[+orderIndex].items;
      }
      return [];
    },
  },
  methods: {
    itemsTotal(items) {
      return items.reduce((accumulator, currentValue) => accumulator + currentValue.price, 0);
    },
    handleConfirm(index) {
      this.order.orderIndex = index;
      this.$modal.show('confirmOrderModal');
    },
    handleReplace(index, mode) {
      this.order.orderIndex = index;
      this.replaceMode = mode;

      this.$modal.show('replacementModal');
    },
    async handleConfirmTime() {
      const { uid } = auth.currentUser;
      const { orderIndex, time } = this.order;
      const order = this.pendingOrders[orderIndex];
      try {
        await db
          .collection(`/restaurants/${uid}/orders`)
          .doc(order.id)
          .update({ status: 'approved', approvedTime: new Date(), prepTime: +time });
        this.order = {
          time: '',
          orderIndex: '',
          replacement: {
            name: '',
            reason: '',
          },
        };
        this.$modal.hide('confirmOrderModal');
        this.$toasted.success(this.$t('Order approved!'), {
          theme: 'bubble',
          position: 'top-center',
          duration: 3000,
        });
      } catch (e) {
        console.log('e :', e);
      }
    },
    handleReject(index, type) {
      this.order.orderIndex = index;
      this.rejectMode = type;
      this.$modal.show('rejectOrderModal');
    },
    async handleConfirmReject() {
      const { uid } = auth.currentUser;
      const { orderIndex, rejectReason } = this.order;
      let order;
      if (this.rejectMode === 'pending') {
        order = this.pendingOrders[orderIndex];
      } else {
        order = this.inProgressOrders[orderIndex];
      }
      try {
        await db
          .collection(`/restaurants/${uid}/orders`)
          .doc(order.id)
          .update({ status: 'rejected', rejectReason });
        this.order = {
          time: '',
          orderIndex: '',
          rejectReason: '',
          replacement: {
            name: '',
            reason: '',
          },
        };
        this.$modal.hide('rejectOrderModal');
        this.$toasted.info(this.$t('Order rejected!'), {
          theme: 'bubble',
          position: 'top-center',
          duration: 3000,
        });
      } catch (e) {
        console.log('e :', e);
      }
    },
    async handleConfirmReplacement() {
      const { uid } = auth.currentUser;
      const { orderIndex } = this.order;

      let order;
      if (this.replaceMode === 'pending') {
        order = this.pendingOrders[orderIndex];
      }
      if (this.replaceMode === 'rejected') {
        order = this.customerRejectedOrders[orderIndex];
      }
      const { menu } = this;
      const replacements = [];
      const { replacementReason } = this;

      Object.entries(this.replacements).forEach(entry => {
        const original = { ...order.items[entry[0]], index: +entry[0] };
        const replacement = { ...menu[entry[1]], index: +entry[0] };
        replacements.push({
          original,
          replacement,
        });
      });

      try {
        await db
          .collection(`/restaurants/${uid}/orders`)
          .doc(order.id)
          .update({ status: 'replacementSent', replacements, replacementSentTime: new Date(), replacementReason });
        this.$modal.hide('replacementModal');
        this.replacementReason = '';
        this.$toasted.info(this.$t('Replacement sent!'), {
          theme: 'bubble',
          position: 'top-center',
          duration: 3000,
        });
      } catch (e) {
        console.log(e);
      }
    },
    parseItemsToRow(items) {
      const d = {};
      items.forEach(i => {
        const { name } = i;
        if (d[name]) {
          d[name] += 1;
        } else {
          d[name] = 1;
        }
      });

      return Object.entries(d);
    },
    parseItemDescriptionToRow(items) {
      const d = {};
      items.forEach(i => {
        const { name, description } = i;
        d[name] = description;
      });

      return Object.entries(d);
    },
    timeLeft(item) {
      const { approvedTime, prepTime } = item;
      if (approvedTime && prepTime) {
        const estTimeTotal = moment.unix(approvedTime.seconds).add(prepTime, 'minutes');
        const now = moment();
        const minDif = moment.duration(now.diff(estTimeTotal)).minutes();
        const secDif = moment.duration(now.diff(estTimeTotal)).seconds();

        if (now.isAfter(estTimeTotal)) {
          return { min: 0, sec: 0 };
        }
        return { min: minDif * -1, sec: secDif * -1 };
      }
      return { min: 0, sec: 0 };
    },
    handleReplaceItem(payload) {
      const {
        index,
        event: {
          target: { value },
        },
      } = payload;

      this.replacements[index] = +value;
    },
    async handleSendBill(index) {
      const { uid } = auth.currentUser;
      const order = this.waitingBillOrders[index];

      try {
        await db
          .collection(`/restaurants/${uid}/orders`)
          .doc(order.id)
          .update({ status: 'billSent' });

        this.$toasted.success(this.$t('Bill sent!'), {
          theme: 'bubble',
          position: 'top-center',
          duration: 3000,
        });
      } catch (e) {
        console.log('e :', e);
      }
    },

    async handleOrderReady(index) {
      const { uid } = auth.currentUser;

      const order = this.inProgressOrders[index];

      try {
        await db
          .collection(`/restaurants/${uid}/orders`)
          .doc(order.id)
          .update({ status: 'ready' });
        this.order = {
          time: '',
          orderIndex: '',
          rejectReason: '',
          replacement: {
            name: '',
            reason: '',
          },
        };

        this.$toasted.success(this.$t('Order ready!'), {
          theme: 'bubble',
          position: 'top-center',
          duration: 3000,
        });
      } catch (e) {
        console.log('e :', e);
      }
    },
    handleChangeDeliveryTime(index) {
      this.activeOrderIndex = index;
      this.activeOrderTime = this.inProgressOrders[index].prepTime;
      this.$modal.show('changeDeliveryTimeModal');
    },
    async handleConfirmTimeChange() {
      const { uid } = auth.currentUser;

      const { activeOrderIndex, activeOrderTime } = this;
      const { id } = this.inProgressOrders[activeOrderIndex];

      try {
        await db
          .collection(`/restaurants/${uid}/orders`)
          .doc(id)
          .update({ prepTime: +activeOrderTime });
        this.$toasted.success(this.$t('Order prep time changed!'), {
          theme: 'bubble',
          position: 'top-center',
          duration: 3000,
        });
        this.$modal.hide('changeDeliveryTimeModal');
      } catch (e) {
        console.log('e :', e);
      }
    },
    handlePrint(index) {
      const { inProgressOrders } = this;
      const a = window.open('', '', 'height=500, width=500');
      a.document.write('<html>');
      a.document.write('<body>');
      a.document.write(`<strong>Customer Note: ${inProgressOrders[index].note} </strong>`);
      a.document.write('<br/> <strong>Items: </strong>');
      for (let i = 0; i < inProgressOrders[index].items.length; i += 1) {
        a.document.write(`<p>${inProgressOrders[index].items[i].name}</p>`);
      }
      a.document.write('</body></html>');
      a.document.close();
      a.print();
    },
    countDownTimer() {
      setInterval(() => {
        this.inProgressOrders.forEach((order, index) => {
          const { min, sec } = this.timeLeft(order);
          this.inProgressOrders[index].timeLeft = { min, sec };
        });
      }, 1000);
    },
    orderSound() {
      setInterval(() => {
        if (this.pendingOrders.length > 0 || this.customerRejectedOrders.length > 0) {
          const audio = new Audio(ding);
          audio.play();
        }

        if (this.waitingBillOrders.length > 0) {
          const audio = new Audio(billSound);
          audio.play();
        }
      }, 15000);
    },
  },
};
</script>
<style lang="scss"></style>
